// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"105":"95f96a25","473":"750d0b34","618":"1e0929a2","809":"571a6ba6","880":"d9489b11"}[chunkId] + ".chunk.css";
};